import React from 'react';

/** Helpers de présentation extraits de SecurityLogs.tsx (sévérité, type). */

export function getSeverityColor(severity: string): string {
  switch (severity) {
    case 'critical':
      return 'bg-gradient-to-r from-red-600 to-red-700 text-cockpit-text shadow-lg shadow-red-500/50';
    case 'high':
      return 'bg-gradient-to-r from-orange-500 to-orange-600 text-cockpit-text shadow-lg shadow-orange-500/50';
    case 'medium':
      return 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-cockpit-text shadow-lg shadow-yellow-500/50';
    case 'low':
      return 'bg-gradient-to-r from-green-500 to-green-600 text-cockpit-text shadow-lg shadow-green-500/50';
    default:
      return 'bg-gradient-to-r from-gray-500 to-gray-600 text-cockpit-text';
  }
}

export function getSeverityIcon(severity: string): React.ReactElement {
  switch (severity) {
    case 'critical':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'high':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'medium':
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      );
    default:
      return (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      );
  }
}

export function getTypeLabel(type: string): string {
  const labels: Record<string, string> = {
    auth_failure: "Échec d'authentification",
    auth_success: 'Authentification réussie',
    rate_limit_exceeded: 'Limite de requêtes dépassée',
    unauthorized_access: 'Accès non autorisé',
    suspicious_activity: 'Activité suspecte',
    invalid_token: 'Token invalide',
    permission_denied: 'Permission refusée',
    data_tampering: 'Manipulation de données',
    sql_injection_attempt: "Tentative d'injection SQL",
    xss_attempt: 'Tentative XSS',
  };
  return labels[type] || type;
}

export function getTypeIcon(type: string): string {
  if (type.includes('auth')) return '🔐';
  if (type.includes('rate_limit')) return '⏱️';
  if (type.includes('unauthorized') || type.includes('permission')) return '🚫';
  if (type.includes('suspicious')) return '⚠️';
  if (type.includes('injection') || type.includes('xss')) return '💉';
  return '📋';
}
